const Mark = ({ size = 36 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        aria-hidden="true"
        className="shrink-0"
    >
        <rect width="64" height="64" rx="14" fill="#080808" />
        <rect
            x="0.75"
            y="0.75"
            width="62.5"
            height="62.5"
            rx="13.25"
            fill="none"
            stroke="#E9EAEF"
            strokeOpacity="0.7"
            strokeWidth="1.5"
        />
        <line x1="24" y1="20" x2="24" y2="46" stroke="#E31B23" strokeWidth="2" strokeLinecap="round" />
        <rect x="19" y="27" width="10" height="12" rx="2" fill="#E31B23" />
        <line x1="41" y1="12" x2="41" y2="54" stroke="#1677FF" strokeWidth="2" strokeLinecap="round" />
        <rect x="34" y="19" width="14" height="27" rx="2.5" fill="#1677FF" />
    </svg>
);

const Logo = ({ size = 36 }) => (
    <div className="flex items-center gap-3">
        <Mark size={size} />
        <div className="leading-none">
            <p
                className="whitespace-nowrap font-display font-extrabold tracking-tight text-white"
                style={{ fontSize: size * 0.44 }}
            >
                ENGULF SUMMIT <span className="text-flame">26</span>
            </p>
            <p
                className="whitespace-nowrap font-mono uppercase text-white/45"
                style={{
                    fontSize: size * 0.2,
                    letterSpacing: "0.18em",
                    marginTop: size * 0.1,
                }}
            >
                QOD × Cikgu Irfan
            </p>
        </div>
    </div>
);

export default Logo;
